import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/ProjectsViewOptionsQuery.graphql';
import type { ExtraProps } from './ProjectsViewOptions.tsx';

type EntryPointParams = { cloudId: string } & ExtraProps;
export const ProjectsViewOptionsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-projects-view-options" */ './ProjectsViewOptions.tsx').then(
			({ ProjectsViewOptions }) => ProjectsViewOptions,
		),
	),
	getPreloadProps: ({ cloudId, onChange }: EntryPointParams) => ({
		queries: {
			projectsViewOptions: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: { cloudId },
			},
		},
		extraProps: { onChange },
	}),
});
